import { assetUrl } from 'src/single-spa/asset-url';
import {
  Component,
  EventEmitter,
  forwardRef,
  Host,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
  SkipSelf
} from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, UntypedFormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ITimeSlot, PartOfTheDay } from '@signal/asp-data-commons';

@Component({
  selector: 'app-time-slot',
  templateUrl: './time-slot.component.html',
  styleUrls: ['./time-slot.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TimeSlotComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TimeSlotComponent),
      multi: true
    }
  ]
})
export class TimeSlotComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() formControlName: string;
  @Input() timeSlots: ITimeSlot[] = [];
  @Input() isAvailabilityLoading: boolean;
  @Input() isTimeSlotDisabled:boolean;
  @Input() source: string;
  @Input() override = {allow: false, date: ''};
  @Output() timeSlotValidator: EventEmitter<boolean> = new EventEmitter();
  @Output() disableOverride: EventEmitter<boolean> = new EventEmitter();

  filteredTimeSlots: ITimeSlot[] = [];
  selectedPartOfDay: string;

  public selectedTimeSlot: string;

  private control: AbstractControl;

  imageUrl = assetUrl('icons/ic-20-utility-time-clock.svg');

  constructor(@Optional() @Host() @SkipSelf()
  private readonly controlContainer: ControlContainer) { }

  ngOnInit(): void {
    this.onPartOfDayChange(PartOfTheDay.MORNING);
    this.control = this.controlContainer.control.get(this.formControlName);
  }

  onChange: any = () => {
    this.filteredTimeSlots = this.timeSlots?.filter(x => x.partOfTheDay === this.selectedPartOfDay);
  }

  onTouched: any = () => { };

  onPartOfDayChange(part: string) {
    this.selectedPartOfDay = part;
    this.filteredTimeSlots = this.timeSlots?.filter(x => x.partOfTheDay === part);
  }

  onSlotChange(slot: ITimeSlot) {
    this.selectedTimeSlot = (slot.timeSlotId);
    this.control.setValue(this.selectedTimeSlot);
    this.onChange(this.selectedTimeSlot);
    this.onTouched();
    this.timeSlotValidator.emit(false);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.selectedTimeSlot = value;
      this.onPartOfDayChange(this.timeSlots?.find(x => x.timeSlotId === value)?.partOfTheDay);
    }

    if (value === null) {
      this.control.reset();
    }

    if(value === "") {
      this.selectedTimeSlot = "";
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  get value(): string {
    return this.control.value;
  }

  set value(value: string) {
    this.selectedTimeSlot = value;
    this.onChange(value);
    this.onTouched();
  }

  get PartOfTheDay() {
    return PartOfTheDay;
  }

  validate(_: UntypedFormControl) {
    return this.control.valid ? null : { valid: false };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty(('timeSlots')) && changes.timeSlots.currentValue) {
      this.selectedPartOfDay = this.timeSlots?.find(x => x.timeSlotId === this.selectedTimeSlot)?.partOfTheDay;
      if(!this.selectedPartOfDay){
        this.selectedPartOfDay = PartOfTheDay.MORNING;
      }
      this.filteredTimeSlots = this.timeSlots?.filter(x => x.partOfTheDay === this.selectedPartOfDay);
      if(this.override.allow) {
        this.selectedPartOfDay = this.timeSlots?.find(x => x.isOpen)?.partOfTheDay;
        this.filteredTimeSlots = this.timeSlots?.filter(x => x.partOfTheDay === this.selectedPartOfDay);
        this.disableOverride.emit(true);
      }
    } else if(!changes.hasOwnProperty(('override')) || changes?.timeSlots?.firstChange) {
        this.selectedPartOfDay = PartOfTheDay.MORNING;
        this.filteredTimeSlots = [];
      }
    }
}
